import { render, staticRenderFns } from "./mobile-detail.vue?vue&type=template&id=8927c51a&scoped=true&"
import script from "./mobile-detail.vue?vue&type=script&lang=ts&"
export * from "./mobile-detail.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-detail.vue?vue&type=style&index=0&id=8927c51a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8927c51a",
  null
  
)

export default component.exports